// =========================================================
// * Vuetify Material Dashboard PRO - v2.0.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import './plugins/vue-moment'
import './plugins/vuetify-datetime-picker'
import vuetify from './plugins/vuetify'
import i18n from './i18n'

// loading overlay
import LoadingOverlay from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.use(LoadingOverlay)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')

Vue.filter('getStockStatusName', function (status) {
  switch (status) {
    case 0:
      return 'Draft'
    case 1:
      return 'Active'
    case 2:
      return 'Closed'
    case 3:
      return 'Error'
    case 4:
      return 'Without invoice'
    default:
      return ''
  }
})
